export const preserveModeIds = ["local", "cloud"] as const;

export type PreserveModeId = (typeof preserveModeIds)[number];

export interface PreserveMode {
  id: PreserveModeId;
  label: string;
  route: readonly string[];
  summary: string;
}

export const preserveModes: Readonly<Record<PreserveModeId, PreserveMode>> = {
  local: {
    id: "local",
    label: "Local Export",
    route: ["Trello", "Browser", "ZIP"],
    summary: "Create a ZIP now. Board content stays in this browser.",
  },
  cloud: {
    id: "cloud",
    label: "Cloud Preserve",
    route: ["Trello", "Secure cloud", "History & restore"],
    summary: "Schedules, copied attachments, history, and recovery.",
  },
};

export const localExportPreflight = [
  {
    id: "tab",
    label: "Keep this Trello tab open until the ZIP downloads.",
  },
  {
    id: "size",
    label: "Large boards may exceed the browser's available memory.",
  },
  {
    id: "attachments",
    label: "Attachment links are included; attachment files are not copied.",
  },
  {
    id: "recovery",
    label:
      "This export has no schedule, cloud history, retries, or managed restore.",
  },
] as const;

export type LocalExportPreflightId =
  (typeof localExportPreflight)[number]["id"];

export function isLocalExportPreflightComplete(
  acknowledgements: ReadonlySet<LocalExportPreflightId>,
): boolean {
  return localExportPreflight.every(({ id }) => acknowledgements.has(id));
}
